import React, {useEffect,useState } from "react"; 
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {logContent} from "../../../Services/logsServices"
const ViewLogs = ({ isShow,close,fileName }) => {
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [logs, setLogs] = useState([]);
  const errorLogContent = "Data loading......";
  useEffect(()=>{
    logContent(fileName).then((response)=>{
      const data=response.data;
      setLogs(data.split('\n'))  
    })
  },[fileName])
  useEffect(() => { 
    setShow(isShow)
  }, [isShow]); 
  return ( 
    <Modal show={show} onHide={handleClose} backdrop="static" dialogClassName="modal-xl">
        <Modal.Header closeButton>
        <h5 className="modal-title">Log : {fileName}</h5>
        </Modal.Header>
        <Modal.Body>
        <form className="row g-3 needs-validation" id="createGameForm"  method="post" enctype="multipart/form-data">
              
              <div className="col-12 px-3">
                  <label htmlFor="NewSubscriptionPlanName" className="form-label">Log data</label>
                  <div className="form-control" id="logDatadDiv" style={{ height: '400px',overflow:"scroll"}}>
                    {logs.length===0?errorLogContent:""}
                    {logs.map((line, index) => (
                      <React.Fragment key={index}>
                        {line} <br /> <br /> 
                      </React.Fragment>
                    ))} 
                  </div>
                </div>
            </form>          
        </Modal.Body>
        <Modal.Footer>
             
        </Modal.Footer>
      </Modal>
       
  );
};

export default ViewLogs;
